import { Component, OnInit } from '@angular/core';
import { IEdificios } from '../interfaces/Edificios';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IMonitorVentasCertificadas } from '../interfaces/MonitorVentasCertificadas';
import { IMarcas } from '../interfaces/Marcas';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { IFiltrosMonitorVentasCertificadas } from '../interfaces/FiltrosMonitorVentasCertificadas';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { IMeses } from '../interfaces/IMeses';

@Component({
  selector: 'app-monitor-ventas-certificadas',
  templateUrl: './monitor-ventas-certificadas.component.html',
  styleUrls: ['./monitor-ventas-certificadas.component.css']
})
export class MonitorVentasCertificadasComponent implements OnInit {

  edificios: Array<IEdificios>;
  marcas: Array<IMarcas>;
  term: string;
  dia:Date;
  edificio: string;
  formMonitor: FormGroup;
  resultadoConsulta: IMonitorVentasCertificadas[];
  submitted = false;
  formatedDate : any;
  selectedEstado: string;
  annios: Array<number> = [];
  meses: Array<IMeses> = [];
  anio: string;
  mes: string;
  //save: boolean = true;

  constructor( private registroServicios: RegistroVentasService,
    private readonly formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private toaster: ToastrService) { }

  ngOnInit(): void {
    this.getEdificiosRegistro(environment.edificiosAutorizados, environment.marcasAutorizadas);
   this.construirFromularioRegistro();
   this.cargaAnnio();
   this.cargarMeses();
  
  }

  construirFromularioRegistro() {
    this.formMonitor = this.formBuilder.group({
      edificio: ['', Validators.required],
      dia: ['']
    });
  }

 /* get f() { return this.formMonitor.controls; }*/

   getEdificiosRegistro(edificios: string, marcas: string) {

    this.registroServicios.getEdificiosRegistro(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

  getMonitorVentas() {
    this.spinner.show();
    const filtros: IFiltrosMonitorVentasCertificadas = {
      ...this.formMonitor.value
    };

 
    var diaSeleccionado = this.dia;
    this.formatedDate =  this.datePipe.transform(diaSeleccionado, "yyyy-MM-dd");
    filtros.Dia =   diaSeleccionado == undefined ||  diaSeleccionado == null ? this.formatedDate: diaSeleccionado;
    filtros.Edificio = this.edificio;
    filtros.Periodo = this.anio+this.mes;


    this.registroServicios.getMonitorVentasCertificadas(filtros).subscribe(
      resolve => {
        if(resolve.length != 0)
        {
          resolve.forEach(item => item.save = (item.estado == "Aprobado" || item.estado == "Pendiente") ? true:false);
          this.resultadoConsulta = resolve; 
          
          this.spinner.hide();
      }
      else{
        Swal.fire('No se encontraron registros.');
        this.spinner.hide();
      }
    },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  
  actualizarRegistroVentasCertificada(item:IMonitorVentasCertificadas) {
    item.comentarios = item.comentarios == ""? " ": item.comentarios;
    item.usuario = environment.userEmailLogged;
    if(item.estado == "Rechazado" && item.comentarios.length < 5)
    {
      Swal.fire({
        title: 'Comentario requerido',
        icon: 'info',
        text:'Cuando el estado es Rechazado el comentario es obligatorio y debe contener una justificacion superior a 5 caracteres',
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,

      })
    }else{

        this.registroServicios.actualizarRegistroVentasCertificada(item)
          .subscribe(e => {
            item.save = true;
            this.toaster.success('Pactia Ventas', 'Se ha actualizado con éxito!.');
          }
        );
      
    }
 }

 
  estadosAprobacion = [
      { id: 'Aprobado', name: 'Aprobado' },
      { id: 'Rechazado', name: 'Rechazado'}
  ];
  estadoChange(item:IMonitorVentasCertificadas)
  {
    item.save = false;
  }
  cargaAnnio() {
    var annioActual = new Date().getFullYear();

    for (let i = 2021; i <= annioActual; i++) {
      this.annios.push(i);
     
    }

  }

  cargarMeses(){
    this.meses.push( 
      { Value: '1', Text: 'Enero' },
      { Value: '2', Text: 'Febrero' },
      { Value: '3', Text: 'Marzo' },
      { Value: '4', Text: 'Abril' },
      { Value: '5', Text: 'Mayo' },
      { Value: '6', Text: 'Junio' },
      { Value: '7', Text: 'Julio' },
      { Value: '8', Text: 'Agosto' },
      { Value: '9', Text: 'Septiembre' },
      { Value: '10', Text: 'Octubre' },
      { Value: '11', Text: 'Noviembre' },
      { Value: '12', Text: 'Diciembre' }
    );
    

    
  }

}

